<template>
  <div class="user-list">
    <Row>
      <Col :xs="24"
           :sm="12">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">

        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.type_id"
                  clearable
                  filterable
                  placeholder="类型">
            <Option v-for="item in typeList"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 placeholder="请输入手机号查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           ref="userList"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "user-list",
  data () {
    return {
      tablelist: [],
      formItem: {
        key: ""
      },
      typeList: [
        { id: 0, name: "商品" },
        { id: 1, name: "现金" },
      ],
      dataloading: false,
      loading: false,
      showEditPwdStatus: false,
      pages: {
        page: 1,
        size: 10
      },
      id: 0,
      datePic: [], //日期
      params: {
        datetime: [],
      },
      list: [
        {
          title: "ID",
          width: 180,
          key: "id",
          fixed: "left",
        },
        {
          title: "手机号",
          width: 150,
          key: "phone",
        },
        {
          title: "名称",
          width: 150,
          key: "title"
        },
        {
          title: "分类名称",
          width: 150,
          key: "type_name"
        },
        {
          title: "订单号",
          width: 250,
          key: "order_num"
        },
        {
          title: "发送时间",
          width: 150,
          key: "created_at"
        },
        // {
        //   title: "操作",
        //   key: "action",
        //   fixed: "right",
        //   width: 350,
        //   align: "left",
        //   render: (h, params) => {
        //     return h("div", [
        //       h(
        //         "Button",
        //         {
        //           style: {
        //             marginRight: "8px"
        //           },
        //           props: {
        //             type: "primary",
        //             size: "small"
        //           },
        //           on: {
        //             click: () => {
        //               this.showEditPwd(params.row.uuid);
        //             }
        //           }
        //         },
        //         "改密"
        //       ),

        //     ]);
        //   }
        // }
      ]
    };
  },
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.giveawardku.loglist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    //选择日期
    changeDate (val) {
      this.formItem.datetime = val;
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    changeDate (val) {
      this.params.datetime = val;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var bgn_date =
        this.params.datetime[0] != undefined ? this.params.datetime[0] : "";
      var end_date =
        this.params.datetime[1] != undefined ? this.params.datetime[1] : "";
      var ps = {
        key: this.formItem.key,
        type_id: this.formItem.type_id,
        page: this.pages.page,
        size: this.pages.size,
        starttime: bgn_date,
        endtime: end_date,
      };
      this.$api.giveawardku.loglist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },

  }
};
  </script>
  
  <style scoped>
</style>